import { redirect } from "react-router-dom";
import { getSession } from "../authApi";
import { can } from "./Permissions";
import { PARAMS } from "./GlobalConstants";

const LOGIN_REDIRECT =
  "/auth?" + PARAMS.mode.mode + "=" + PARAMS.mode.login;

export async function tokenLoader() {
  return getSession();
}

export async function checkAuthLoader() {
  const user = await getSession();

  if (!user) {
    return redirect(LOGIN_REDIRECT);
  }

  return null;
}

export async function checkAuth() {
  const user = await getSession();

  if (user) {
    return redirect("/");
  }

  return null;
}

// Route guard for a single capability. Signed-out users land on the login
// screen; signed-in users who simply lack the capability are sent home rather
// than to login, since re-authenticating would not help them. The server
// enforces the same rule - this only keeps the UI honest.
export function requireCapability(capability) {
  return async function capabilityLoader() {
    const user = await getSession();

    if (!user) {
      return redirect(LOGIN_REDIRECT);
    }

    if (!can(user, capability)) {
      return redirect("/");
    }

    return null;
  };
}
